//#region src/components/ui/sidebar/locale/en_US.ts
var e = { toggleSidebar: "Toggle Sidebar" };
//#endregion
export { e as sidebarLocale };

//# sourceMappingURL=en_US.js.map